import { h } from 'preact';
import { showModal, alert, toast } from 'utils/modal';
import { isFocusStudio } from 'utils/studioConfig';

import FocusAddMovieModal from 'components/movies/addMovieModal/addMovieModalFocus';
import UniversalAddMovieModal from 'components/movies/addMovieModal/addMovieModalUniversal';

export const AddMovieModal = (props) => {
	if (isFocusStudio()) return <FocusAddMovieModal {...props} />;
	return <UniversalAddMovieModal {...props} />;
};

export async function addMovie() {
	try {
		const result = await showModal(AddMovieModal);
		if (!result || result === 'CANCEL') return null; // User cancelled the modal

		const newMovie = JSON.parse(result); // Parse the JSON string returned from the modal
		return newMovie;
	} catch (err) {
		console.error('Error adding movie:', err);
		alert('An unexpected error occurred while adding the movie. Please try again.', { title: 'Error' });
		return null;
	}
}